import { defineFcm } from '../shared/factory';

export const FCM_CORGI_SSR_RENDER_TIMEOUT_MS = defineFcm('corgi_ssr_render_timeout_ms')
	.asNumber()
	.withDefault(10000)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		context: 'corgi SSR',
		description: `Timeout (in milliseconds) after which an in-progress SSR render (renderToPipeableStream) is aborted.
			A value <= 0 disables the timeout (no abort).`,
	});
